import { httpClient } from '@/network/clientController'

/** Get Frequent Operations list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetfrequentoperations
*/
export const getFrequentOperations = (payload) => {
    return httpClient({
		method: 'GET',
		url: 'frequent/operations',
        params: payload
	})
}
